module.exports = __webpack_public_path__ + "static/media/plaque_cup_2023.a981a79d.jpg";